module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 58.316 58.344",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#video-play",
      toString: function () {
        return this.url;
      }
    }